import React from 'react';
import styled from 'styled-components';
import { SuiLabel, SuiField } from '@splashthat/sui';
import noop from 'lodash/noop';
import { PropTypes } from 'prop-types';
import intersection from 'lodash/intersection';
import DraftTextEditor from '../../DraftTextEditor';

const FIELD_VARIATIONS = ['error'];

const Container = styled.div`
    /* prevents DraftTextEditor value from going outside the input field when it's long */
    .SuiField__current {
        overflow: auto;
    }
`;

export default class DraftTextEditorWrapper extends React.Component {
    state = {
        hasValue: !!(this.props.value || this.props.defaultValue),
    };

    static propTypes = {
        value: PropTypes.string,
        defaultValue: PropTypes.string,
        label: PropTypes.string,
        variation: PropTypes.string,
        placeholder: PropTypes.string,
        onChangeLabel: PropTypes.func,
        disableBold: PropTypes.bool,
        disableLink: PropTypes.bool,
        disabled: PropTypes.bool,
        maxByteLimit: PropTypes.number,
        enableCharacterCountdown: PropTypes.bool,
    };

    static defaultProps = {
        value: '',
        defaultValue: null,
        label: '',
        variation: null,
        placeholder: null,
        onChangeLabel: noop,
        disableBold: false,
        disableLink: false,
        disabled: false,
        maxByteLimit: null,
        enableCharacterCountdown: false,
    };

    hasValue = (event, { label, labelMarkup }, hasValue) => {
        this.props.onChangeLabel(event, label, labelMarkup);
        this.setState({ hasValue });
    };

    render() {
        const { value, label, variation, placeholder, defaultValue, disableBold, disableLink, disabled } = this.props;

        const fieldVariation = intersection((variation || '').split(' '), FIELD_VARIATIONS).join(' ');

        return (
            <Container>
                {label && <SuiLabel variation={fieldVariation}>{label}</SuiLabel>}
                <SuiField
                    {...this.props}
                    placeholder={this.state.hasValue ? '' : placeholder}
                    disabled={disabled}
                    formElement={
                        <DraftTextEditor
                            {...this.props}
                            value={value}
                            defaultValue={defaultValue || value}
                            onChange={this.hasValue}
                            disableBold={disableBold}
                            disableLink={disableLink}
                            readOnly={disabled}
                        />
                    }
                />
            </Container>
        );
    }
}
